import { render, staticRenderFns } from "./BLPJS01Component.vue?vue&type=template&id=39fcfa67&scoped=true&"
import script from "./BLPJS01Component.vue?vue&type=script&lang=js&"
export * from "./BLPJS01Component.vue?vue&type=script&lang=js&"
import style0 from "./BLPJS01Component.vue?vue&type=style&index=0&id=39fcfa67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fcfa67",
  null
  
)

export default component.exports